import { render, staticRenderFns } from "./distributorAftersalesAddress.vue?vue&type=template&id=3f8a5e0e&scoped=true"
import script from "./distributorAftersalesAddress.vue?vue&type=script&lang=js"
export * from "./distributorAftersalesAddress.vue?vue&type=script&lang=js"
import style0 from "./distributorAftersalesAddress.vue?vue&type=style&index=0&id=3f8a5e0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a5e0e",
  null
  
)

export default component.exports